import { AI_TERMS, AI_TERMS_EFFECTIVE, AI_TERMS_VERSION } from './aiTermsContent'

/** The document itself, without any of the accepting. */
export default function AITermsDocument({ className = '' }: { className?: string }) {
    return (
        <article className={className}>
            <header className='border-b pb-4'>
                <h1 className='text-base font-semibold'>Xpillar Intelligence — Terms of Use</h1>
                <p className='mt-1 text-xs text-muted-foreground'>
                    Version {AI_TERMS_VERSION} · Effective {AI_TERMS_EFFECTIVE}
                </p>
            </header>

            <ol className='mt-5 space-y-5'>
                {AI_TERMS.map((clause, i) => (
                    <li key={clause.heading}>
                        <h2 className='text-sm font-semibold'>
                            {i + 1}. {clause.heading}
                        </h2>
                        <div className='mt-1.5 space-y-2'>
                            {clause.paragraphs.map((text, j) => (
                                <p key={j} className='text-sm leading-relaxed text-gray-700'>
                                    <span className='mr-1.5 text-xs text-muted-foreground'>
                                        {i + 1}.{j + 1}
                                    </span>
                                    {text}
                                </p>
                            ))}
                        </div>
                    </li>
                ))}
            </ol>

            <p className='mt-6 border-t pt-4 text-xs leading-relaxed text-muted-foreground'>
                Accepting these terms records your agreement against your Hero account, with the date and version. They apply in addition to the Xpillar
                terms of use and privacy policy.
            </p>
        </article>
    )
}
